import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Card, CardBody, Row, Col, Alert, Table } from 'reactstrap';
import { metadataService } from "../../_services";
import { refinanceIncreaseLoanActions, userActions, profileActions } from "../../_actions";
import { ReadOnlyField, SlButton } from "../editors";
import { history } from "../../_helpers"
import { PaymentBreakdown } from "./PaymentBreakdown";

class LoanInfoView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPaymentBreakdown: false,
            showPayoffBreakdown: false,
        };
    }

    refinanceDispatch = () => {
        this.props.actions.refinanceMenu();
    };

    handleMakePayment = () => {
        let loanId = this.props.loanView.currentLoanId;
        history.push('make-payment/' + loanId);
    }

    togglePaymentBreakdown = () => {
        if (this.props.loanView.suggestedPayment == 0) {
            this.setState({
                showPaymentBreakdown: false
            })
        } else {
            this.setState({
                showPaymentBreakdown: !this.state.showPaymentBreakdown
            })
        }
    }

    togglePayoffBreakdown = () => {
        this.setState({
            showPayoffBreakdown: !this.state.showPayoffBreakdown
        })
    }

    render() {
        return (
            <div >
                {/* <h5>{metadataService.getFieldNameLabel("CurrentLoanId")} : {this.props.loanView.currentLoanId}</h5> */}
                <Card>
                    <CardBody className={"p-0"}>
                        <Table bordered={true}>
                            <tbody>
                                <tr>
                                    <td className="font-weight-bold border-right-0">
                                        {metadataService.getFieldNameLabel("CurrentLoanId")}
                                    </td>
                                    <td className="border-left-0">
                                        {metadataService.maskExceptLastFourCharacters(this.props.loanView.currentLoanId.toString())}
                                    </td>
                                </tr>
                                <tr>
                                    <td className="font-weight-bold border-right-0">
                                        {metadataService.getFieldNameLabel("OriginalLoanAmount")}
                                    </td>
                                    <td className="border-left-0">
                                        {metadataService.formatMoney(this.props.loanView.originalLoanAmount)}
                                    </td>
                                </tr>
                                {this.props.loanView.thirdPartyName == null && (
                                    <tr>
                                        <td className="font-weight-bold border-right-0">
                                            {metadataService.getFieldNameLabel("Balance")}
                                        </td>
                                        <td className="border-left-0">
                                            {metadataService.formatMoney(this.props.loanView.balance)}
                                        </td>
                                    </tr>)
                                    && (
                                        <tr onClick={() => this.togglePayoffBreakdown()}>
                                            <td className="font-weight-bold border-right-0">
                                                {metadataService.getFieldNameLabel("Payoff")}
                                                &nbsp;
                                                <span className="font-weight-normal">
                                                    (
                                                    {metadataService.getFieldNameLabel("PayoffGoodUntil")}
                                                    &nbsp;
                                                    {metadataService.formatDateString(this.props.loanView.payoffGoodUntilDate)}
                                                    )
                                                </span>
                                            </td>
                                            <td className="border-left-0 twisty" aria-expanded={this.state.showPayoffBreakdown}>
                                                {metadataService.formatMoney(this.props.loanView.payoff)}
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>

                            {this.state.showPayoffBreakdown && (
                                <PaymentBreakdown loan={this.props.loanView} breakdownType='payoff' />
                            )}
                            <tbody className="border-top-0">
                                {this.props.loanView.thirdPartyName == null &&

                                    <tr onClick={() => this.togglePaymentBreakdown()} >
                                        <td className="font-weight-bold border-right-0">
                                            {metadataService.getFieldNameLabel("Payment")}
                                        </td>
                                        {this.props.loanView.suggestedPayment > 0 ?
                                            <td className="border-left-0 twisty" aria-expanded={this.state.showPaymentBreakdown}>
                                                {metadataService.formatMoney(this.props.loanView.suggestedPayment)}
                                            </td>
                                            :
                                            <td className="border-left-0">
                                                {metadataService.formatMoney(this.props.loanView.suggestedPayment)}
                                            </td>
                                        }
                                    </tr>}
                            </tbody>

                            {this.state.showPaymentBreakdown && (
                                <PaymentBreakdown loan={this.props.loanView} breakdownType='payment' />
                            )}

                            <tbody className="border-top-0">
                                {this.props.loanView.thirdPartyName == null &&
                                    <tr>
                                        <td className="font-weight-bold border-right-0">
                                            {metadataService.getFieldNameLabel("PaymentDueDate")}
                                        </td>
                                        <td className="border-left-0">
                                            {metadataService.formatDateString(this.props.loanView.paymentDueDate)}
                                        </td>
                                    </tr>}
                            </tbody>
                        </Table>
                        {this.props.loanView.isPastDue && !this.props.loanView.isPaymentInProcess && this.props.loanView.thirdPartyName === null && (
                            <Row >
                                <Alert color='danger' className="w-100">{metadataService.getMessage('PaymentPastDue')}</Alert>
                            </Row>
                        )}
                        {this.props.loanView.isPaymentDeclined && (
                            <Row >
                                <Alert color='warning' className="w-100">{metadataService.getMessage('PaymentDeclined')}</Alert>
                            </Row>
                        )}
                        {(this.props.loanView.isPaymentInProcess || this.props.loanView.hasPayments) && !this.props.loanView.isPaymentSettled && (
                            <Row >
                                <Alert color='primary' className="w-100">{metadataService.getMessage('PaymentInProcess')}</Alert>
                            </Row>
                        )}
                        {this.props.showPaymentButton && (
                            < Row className="text-center mb-3">

                                <Col>
                                    <SlButton name="MakePayment" onClick={this.handleMakePayment} disabled={this.props.loanView.isPaymentInProcess} />
                                </Col>
                                <Col>
                                    {this.props.showIncreaseRefinance && (
                                        <SlButton
                                            name="RefinanceDispatch"
                                            id="increaseRefinance"
                                            onClick={this.refinanceDispatch}
                                            to="/"
                                        >

                                        </SlButton>
                                    )}
                                </Col>
                            </Row>
                        )}
                    </CardBody>
                </Card></div >
        );
    }
}
//Declare our proptypes. 
LoanInfoView.propTypes = {
    //This loan view JSON object. 
    loanView: PropTypes.object.isRequired,
    showPaymentButton: PropTypes.bool,
    showIncreaseRefinance: PropTypes.bool
}

function mapStateToProps(state) {
    return {
        language: state.users.language
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            refinanceMenu: () => {
                dispatch(refinanceIncreaseLoanActions.handleRefinanceMenuClick());
            }
        }
    };
}

const connectedLoanInfoView = connect(
    mapStateToProps,
    mapDispatchToProps
)(LoanInfoView)

export { connectedLoanInfoView as LoanInfoView };



// WEBPACK FOOTER //
// ./src/components/subcomponents/loanInfoView.js